import useApi from '@/composables/api/useApi'

export default function useDirectSalesApi() {
  const { directSalesFormUrl } = useRuntimeConfig().public
  const { fetchApi } = useApi(directSalesFormUrl ?? '')

  const submitLead = async (payload: Record<string, unknown>) => {
    return await fetchApi('', {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  return { submitLead }
}
